import {action, observable, runInAction} from 'mobx'
import {decorate, inject, injectable} from '@yosmanyga/di'
import {AuthenticationFrontendWithEmailAbstractApi} from '../../data'

class AuthenticationFrontendWithEmailStartController {
    @observable accessor email: string | undefined
    @observable accessor error!: string
    @observable accessor loading: boolean
    @observable accessor starting: boolean

    constructor(
        private authenticationFrontendApi: AuthenticationFrontendWithEmailAbstractApi,
    ) {
        this.loading = true
        this.starting = false
    }

    @action load = (
        email?: string
    ) => {
        runInAction(() => {
            this.email = email
            this.loading = false
        })
    }

    @action prepare = (
        email: string | undefined
    ) => {
        runInAction(() => {
            this.error = ''
            this.email = email
        })
    }

    @action start = async () => {
        runInAction(() => {
            this.error = ''
            this.starting = true
        })

        if (!this.email) {
            runInAction(() => {
                this.error = 'Email is required'
                this.starting = false
            })

            return
        }

        await this.authenticationFrontendApi.start(
            this.email as string
        )

        runInAction(() => {
            this.starting = false
        })
    }
}

decorate(injectable(), AuthenticationFrontendWithEmailStartController)
decorate(inject(AuthenticationFrontendWithEmailAbstractApi), AuthenticationFrontendWithEmailStartController, 0)

export {
    AuthenticationFrontendWithEmailStartController
}
